import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { Input } from "@material-ui/core";

// import { Button } from "devextreme-react/button";
import { DateBox } from "devextreme-react/date-box";
import { Switch } from "devextreme-react/switch";
import { TextBox } from "devextreme-react/text-box";
import { useEffect, useRef, useState, Fragment } from "react";
import { useSelector } from "react-redux";
import Centerlist from "../Centerlist";
import StatusCodeList from "../StatusCodeList";
import { useAuth0 } from "@auth0/auth0-react";
import DatePicker from "react-date-picker";
import moment from "moment";
import { useDispatch } from "react-redux";
import { postQueryHandler } from "../../Middleware/postQueryMethod";
import { RadioGroup } from 'devextreme-react/radio-group';
import {
    centerPreFixFunc,
    centerSelectFunc,
    clearConversationIdFunc,
    SetError,
    setIsReferralFormfetchingFunc,
} from "../../redux-store/actions";
import { GET_UNCONCLUDED_CALLS, GET_ALL_CALLS } from "../../utils/endPoints";
import {
    Button,
    ButtonGroup,
    ButtonToolbar,
    InputGroup,
} from "react-bootstrap";
import styles from "./SearchBar.module.css";
import styled from "styled-components";
import { Routes, Route, useParams, useLocation } from 'react-router-dom';
import { error_codes } from '../../ConstVariable';
import { SelectBox } from "devextreme-react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
const CenterDropDown = styled.div`
  border-bottom: 1px solid lightgrey;
  font-size: 15px;
  margin-right: 10px;
  cursor: pointer;
  color: #586c72;
  display: flex;
  justify-content: space-between;
  width: 120px;
`;
const InputContainer = styled.div`
  width: 100%;

  ${'' /* @media screen and (min-width:1200px ) and (max-width:1400px) {
    width:90%
  } */}

  ${'' /* border-right: 1px solid; */}
`;
const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  ${'' /* justify-content: space-between; */}
  ${'' /* flex-direction:row-reverse; */}
  ${'' /* width:5%; */}
  ${'' /* @media screen and (min-width:1200px ) and (max-width:1400px) {
    width:10%
  } */}

`;
const SearchInputContainer = styled.div`
  ${"" /* position:fixed; */}
  ${"" /* width:100%; */}
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 8px;
  borderleft: none;
`;

const CallStatusDropDownContainer = styled.div`
  position: absolute;
   top: 30px;
    right: -150px;
    zIndex: 100;


/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) and  (max-width:1500px) {
  right: -610px;
}
@media only screen and (min-width: 1500px) and (max-width:1700px)  {
  right: -610px;
}

`

const ConversationWorkflowTypeDropDownContainer = styled.div`
position:relative;
border:1px solid lightgrey;
${'' /* box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px; */}
${'' /* box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px; */}

`
const ConversationWorkflowTypeDropDown = styled.div`
box-shadow: rgba(17, 17, 26, .4) 0px 0px 16px;
border:1px solid ;
 position: absolute;
 border:5px;
  z-index: 1000;
  background: #D3D3D3;
  ${'' /* border: 1px solid ; */}
  width: 180px;
  top: 5;
  ${'' /* left: 0; */}
 `

const CallSourceDropDownContainer = styled.div`
position:relative;
border:1px solid lightgrey;
${'' /* box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px; */}
${'' /* box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px; */}


`
const UttranceDropDownContainer = styled.div`
position:relative;
border:1px solid lightgrey;
${'' /* box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px; */}
${'' /* box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px; */}

`

const UtteranceSourceDropDown = styled.div`
box-shadow: rgba(17, 17, 26, .4) 0px 0px 16px;
border:1px solid ;
 position: absolute;
 border:5px;
  z-index: 1000;
  background: #D3D3D3;
  ${'' /* border: 1px solid ; */}
  width: 180px;
  top: 5;
  ${'' /* left: 0; */}
 `

const CallSourceDropDown = styled.div`
box-shadow: rgba(17, 17, 26, .4) 0px 0px 16px;
border:1px solid ;
 position: absolute;
 border:5px;
  z-index: 1000;
  background: #D3D3D3;
  ${'' /* border: 1px solid ; */}
  width: 180px;
  top: 5;
  ${'' /* left: 0; */}
 `
const StatusCodeDropdown = styled.div`
  border-bottom: 1px solid lightgrey;


  font-size: 15px;
  margin-right: 10px;
  cursor: pointer;
  color: #586c72;
  display: flex;
  width: 200px;
  justify-content: space-between;
`;



const DOBContainer = styled.div`
  margin-right: 4px;
`;
const VerticalLine = styled.div`
  border-left: 1px solid;
  height: 30px;
  margin-left: 5px;
  margin-right: 5px;
  margin-top: 10px;
`;

const SwitchContainer = styled.div`
  margin-top: 10px;
  margin-left: 3px;
  margin-right: 3px;
`;
const SearchInfoBox = styled.div`
  margin-top: 8px;
  margin-left: -30px;
  font-size: 13px;
  color:red;
  font-weight:500 ;
`;

const CallCountInfo = styled.div``;
const CallCount = styled.div`
  background: yellow;
  color: red;
  font-weight: bolder;
  padding:5px;
  margin-top:5px;

  ${"" /* height: 29px; */}
  ${'' /* marginLeft: 10px; */}
`;
const Buttons = styled.div``;

//NOTE: Call source list
const callSourceTypeList = [
    { id: "VOICE_CALL", text: "Voice Booking", isChecked: false },
    { id: "LANDLINE", text: "Landline", isChecked: false },
    { id: "MOBILE", text: "Mobile", isChecked: false },
    { id: "PBX", text: "PBX", isChecked: false },
    { id: "PRIVATE", text: "Private", isChecked: false },
    { id: "WEBBOT", text: "Webbot Booking", isChecked: false },
    { id: "MANUAL", text: "Operator Booking", isChecked: false },
    { id: "KIOSK", text: "Kiosk", isChecked: false },
    { id: "DIRECT_CALL", text: "Direct Call", isChecked: false }

];

const CONVERSATION_WORKFLOW_MASTER_DATA_SOURCE = [
    { id: "IMAGING_WORKFLOW", text: "Radiology", isChecked: false },
    { id: "GP_WORKFLOW", text: "GP", isChecked: false },
    { id: "DIRECT_CALL", text: "Direct Calls", isChecked: false },
];

const CURRENT_STATE_MASTER_DATA_SOURCE = [{ id: 'BloodTestState::CHECK_IF_PRESCRIPTION_AVAILABLE', text: 'BloodTestState::CHECK_IF_PRESCRIPTION_AVAILABLE', isChecked: false },
{ id: 'BloodTestState::CONFIRM_IF_CALLER_WANTS_APPOINMENT', text: 'BloodTestState::CONFIRM_IF_CALLER_WANTS_APPOINMENT', isChecked: false },
{ id: 'CancellationState', text: 'CancellationState', isChecked: false },
{ id: 'CancellationState::STATE_DOB_CONFIRMATION', text: 'CancellationState::STATE_DOB_CONFIRMATION', isChecked: false },
{ id: 'CancellationState::STATE_DOB_PROMPTED', text: 'CancellationState::STATE_DOB_PROMPTED', isChecked: false },
{ id: 'CardiacDiagnosticTestState::GET_CARDIAC_DIAGNOSTIC_TEST_TYPE', text: 'CardiacDiagnosticTestState::GET_CARDIAC_DIAGNOSTIC_TEST_TYPE', isChecked: false },
{ id: 'DemographicState::CHECK_IF_APPOINTMENT_IS_FOR_EXISTING_PATIENT', text: 'DemographicState::CHECK_IF_APPOINTMENT_IS_FOR_EXISTING_PATIENT', isChecked: false },
{ id: 'DemographicState::STATE_DOB_CONFIRMATION', text: 'DemographicState::STATE_DOB_CONFIRMATION', isChecked: false },
{ id: 'DemographicState::STATE_DOB_PROMPTED', text: 'DemographicState::STATE_DOB_PROMPTED', isChecked: false },
{ id: 'DemographicState::STATE_FNAME_PROMPTED', text: 'DemographicState::STATE_FNAME_PROMPTED', isChecked: false },
{ id: 'DemographicState::STATE_LNAME_PROMPTED', text: 'DemographicState::STATE_LNAME_PROMPTED', isChecked: false },
{ id: 'GreetingState::ADDITIONAL_QUESTION_ASKED', text: 'GreetingState::ADDITIONAL_QUESTION_ASKED', isChecked: false },
{ id: 'GreetingState::CHECK_IF_CALLED_FOR_NEW_APPOINTMENT', text: 'GreetingState::CHECK_IF_CALLED_FOR_NEW_APPOINTMENT', isChecked: false },
{ id: 'GreetingState::GET_REASON_FOR_NON_APPOINTMENT_CALL', text: 'GreetingState::GET_REASON_FOR_NON_APPOINTMENT_CALL', isChecked: false },
{ id: 'GreetingState::MOBILENO_PROMPTED', text: 'GreetingState::MOBILENO_PROMPTED', isChecked: false },
{ id: 'GreetingState::STATE_CONTACTNO_PROMPTED', text: 'GreetingState::STATE_CONTACTNO_PROMPTED', isChecked: false },
{ id: 'GreetingState::STATE_CONTACTNO_VALIDATION', text: 'GreetingState::STATE_CONTACTNO_VALIDATION', isChecked: false },
{ id: 'GreetingState::STATE_MOBILE_VALIDATION', text: 'GreetingState::STATE_MOBILE_VALIDATION', isChecked: false },
{ id: 'GreetingState::USER_MASTER_MENU_SELECTION', text: 'GreetingState::USER_MASTER_MENU_SELECTION', isChecked: false },
{ id: 'InformTimeState', text: 'InformTimeState', isChecked: false },
{ id: 'InformTimeState::CHECK_IF_FEMALE_SONOGRAPHER_REQUIRED', text: 'InformTimeState::CHECK_IF_FEMALE_SONOGRAPHER_REQUIRED', isChecked: false },
{ id: 'MiscellaneousState', text: 'MiscellaneousState', isChecked: false },
{ id: 'MiscellaneousState::AWAIT_DEMOGRAPHIC_CONFIRMATION_MESSAGE', text: 'MiscellaneousState::AWAIT_DEMOGRAPHIC_CONFIRMATION_MESSAGE', isChecked: false },
{ id: 'MiscellaneousState::CHECK_IF_USER_HAS_MEDICARE', text: 'MiscellaneousState::CHECK_IF_USER_HAS_MEDICARE', isChecked: false },
{ id: 'MiscellaneousState::CHECK_IF_USER_HAS_PVT_INSURANCE', text: 'MiscellaneousState::CHECK_IF_USER_HAS_PVT_INSURANCE', isChecked: false },
{ id: 'MiscellaneousState::GET_INSURANCE_NUMBER', text: 'MiscellaneousState::GET_INSURANCE_NUMBER', isChecked: false },
{ id: 'MultiCenterState', text: 'MultiCenterState', isChecked: false },
{ id: 'MultiCenterState::ASK_PREFERRED_CENTER_NAME', text: 'MultiCenterState::ASK_PREFERRED_CENTER_NAME', isChecked: false },
{ id: 'MultiCenterState::CONFIRM_IF_CALLER_HAS_CENTRE_PREFERRENCE', text: 'MultiCenterState::CONFIRM_IF_CALLER_HAS_CENTRE_PREFERRENCE', isChecked: false },
{ id: 'MultiCenterState::CONFIRM_USER_PREFERRED_CENTER', text: 'MultiCenterState::CONFIRM_USER_PREFERRED_CENTER', isChecked: false },
{ id: 'MultiCenterState::REQUEST_FOR_CONFIRMATION_TO_PROCEED_WITH_BOOKING_AT_AVAILABILE_CENTER', text: 'MultiCenterState::REQUEST_FOR_CONFIRMATION_TO_PROCEED_WITH_BOOKING_AT_AVAILABILE_CENTER', isChecked: false },
{ id: 'NewApptState::ASK_DOCTOR_FULLNAME', text: 'NewApptState::ASK_DOCTOR_FULLNAME', isChecked: false },
{ id: 'NewApptState::ASK_FOR_APPOINTMENT_LENGTH', text: 'NewApptState::ASK_FOR_APPOINTMENT_LENGTH', isChecked: false },
{ id: 'NewApptState::CHECK_IF_CALLER_HAS_VISITED_DOC_EARLIER', text: 'NewApptState::CHECK_IF_CALLER_HAS_VISITED_DOC_EARLIER', isChecked: false },
{ id: 'NewApptState::CHECK_PATIENT_HAS_VISITED_THE_CENTER', text: 'NewApptState::CHECK_PATIENT_HAS_VISITED_THE_CENTER', isChecked: false },
{ id: 'NewApptState::CONFIRM_DOCTOR_FULLNAME', text: 'NewApptState::CONFIRM_DOCTOR_FULLNAME', isChecked: false },
{ id: 'NewApptState::CONFIRM_IF_PATIENT_WANTS_TO_PROCEED_WITH_APPONTMENT_AT_AVAILABLE_CENTER', text: 'NewApptState::CONFIRM_IF_PATIENT_WANTS_TO_PROCEED_WITH_APPONTMENT_AT_AVAILABLE_CENTER', isChecked: false },
{ id: 'NewApptState::CONFIRM_NO_SPECIFIC_CHOICE_FOR_THE_LOCATION', text: 'NewApptState::CONFIRM_NO_SPECIFIC_CHOICE_FOR_THE_LOCATION', isChecked: false },
{ id: 'NewApptState::GET_APPOINTMENT_DETAILS', text: 'NewApptState::GET_APPOINTMENT_DETAILS', isChecked: false },
{ id: 'NewApptState::IS_SPECIFIC_DOCTOR_REQUESTED', text: 'NewApptState::IS_SPECIFIC_DOCTOR_REQUESTED', isChecked: false },
{ id: 'NewApptState::SELECT_A_CENTER_FOR_MULTICENTER_SCENARIO', text: 'NewApptState::SELECT_A_CENTER_FOR_MULTICENTER_SCENARIO', isChecked: false },
{ id: 'NewApptState::SELECT_DOCTOR_FROM_MULTIPLE_MATCH', text: 'NewApptState::SELECT_DOCTOR_FROM_MULTIPLE_MATCH', isChecked: false },
{ id: 'ServiceRequestState::ADDITIONAL_QUESTION_ASKED', text: 'ServiceRequestState::ADDITIONAL_QUESTION_ASKED', isChecked: false },
{ id: 'ServiceRequestState::ASK_FOR_SCAN_DETAILS', text: 'ServiceRequestState::ASK_FOR_SCAN_DETAILS', isChecked: false },
{ id: 'ServiceRequestState::ASK_GENDER', text: 'ServiceRequestState::ASK_GENDER', isChecked: false },
{ id: 'ServiceRequestState::ASK_WEEKS_SINCE_PREGNANT', text: 'ServiceRequestState::ASK_WEEKS_SINCE_PREGNANT', isChecked: false },
{ id: 'ServiceRequestState::GET_SPECIFIC_PREGNANCY_PROTOCOL_DETAILS', text: 'ServiceRequestState::GET_SPECIFIC_PREGNANCY_PROTOCOL_DETAILS', isChecked: false },
{ id: 'ServiceRequestState::IMAGING_SERVICE_TRIAGING_STEP', text: 'ServiceRequestState::IMAGING_SERVICE_TRIAGING_STEP', isChecked: false },
{ id: 'ServiceRequestState::PROMPT_ADDITIONAL_COSTING', text: 'ServiceRequestState::PROMPT_ADDITIONAL_COSTING', isChecked: false },
{ id: 'ServiceRequestState::PROMPT_FASTING_DURATION', text: 'ServiceRequestState::PROMPT_FASTING_DURATION', isChecked: false },
{ id: 'ServiceRequestState::SAFETY_QUESTION', text: 'ServiceRequestState::SAFETY_QUESTION', isChecked: false },
{ id: 'ServiceRequestState::SCAN_DETAILS_CONFIRMATION', text: 'ServiceRequestState::SCAN_DETAILS_CONFIRMATION', isChecked: false }];

const callDateTypePriorities = [{ name: "Call Date", id: "CALL_DATE" }, { name: "Appt. Date", id: "APPT_DATE" }];
const showCallOptions = ["ALL CALLS", "COMPLETED CALLS"];
const showUtteranceFilterOptions = [{ name: "PARTIAL", id: "PHRASE" }, { name: "EXACT", id: "EXACT" }];
const initialSearchData = {
    caller_id: "",
    center_id: [],
    conversationWorkflow: "",
    conversation_id: "",
    dob: "",
    end_date: "",
    first_name: "",
    initiator_source: [],
    last_name: "",
    operator_feedback: [],
    start_date: "",
    status: "",
    utterance: "",
    order_description:""
};

const InputFieldWithTitle = ({
    name,
    value,
    InputHandler,
    title,
    type,
    customCss,

}) => {
    return (
        <Fragment>
            <div style={{ marginRight: "10px" }}>
                <label style={{ marginRight: "4px" }}>{title}</label>

                <Input
                    type={type}
                    style={{ ...customCss }}
                    name={name}
                    value={value}
                    onChange={InputHandler}
                />
            </div>
        </Fragment>
    );
};

const SearchBar = ({
    componentIdentity,
    callDataHandler,
    gotNoOfCalls,
    noOfCallsText,
    totalNumberOfCall,
    onSearchClick,
    page_no,
    onResetClick,
    errorDataHandler
}) => {
    const { operatorAssignedCenters } = useSelector((state) => state);

    const location = useLocation()
    const history = useHistory();
    const { user ,logout} = useAuth0();
    const { getAccessTokenSilently } = useAuth0();
    const GetAuthToken = async () => {
        const token = await getAccessTokenSilently();
        return token;
    };
    const dispatch = useDispatch();
    const [centerList, setCenterList] = useState([]);

    const [CallStatusList, setCallStatusList] = useState([]);

    const [resetClick, setResetClick] = useState(false);

    const [showCenterList, setShowCenterList] = useState("none");

    const [selectedCallStatus, setSelectedCallStatus] = useState([]);
    const [selectedCenterIds, setSelectedCenterIds] = useState([]);

    const [callSourceList, setCallSourceList] = useState([...callSourceTypeList]);
    const [selectedCallSource, setSelectedCallSource] = useState([]);

    const [conversationWorkflowListMaster, setConversationWorkflowListMaster] = useState([...CONVERSATION_WORKFLOW_MASTER_DATA_SOURCE]);
    const [selectedConversationWorkflowType, setSelectedConversationWorkflowType] = useState([]);


    const [currentStateMaster, setCurrentStateMaster] = useState([...CURRENT_STATE_MASTER_DATA_SOURCE]);
    const [currentStateList, setCurrentStateList] = useState([...CURRENT_STATE_MASTER_DATA_SOURCE]);
    const [selectedCurrentStates, setSelectedCurrentStates] = useState([]);

    const [callContextList, setCallContextList] = useState([]);
    const [selectedCallContext, setSelectedCallContext] = useState([]);
    const [storedSelectedCallContextList, setStoredSelectedCallContextList] = useState([]);
    const [showUtteranceFilter, setShowUtteranceFilter] = useState(showUtteranceFilterOptions[0]);
    
    const [modalitiesList, setModalitiesList] = useState([]);
    const [selectedModalitiesList, setSelectedModalitiesList] = useState([]);

    const [conversationTagList, setConversationTagList] = useState([]);
    const [selectedConversationTag, setSelectedConversationTag] = useState([]);
    const [storedSelectedConversationTagList, setStoredSelectedConversationTagList] = useState([]);
    const [storedSelectedModalitiesList, setStoredSelectedModalitiesList] = useState([]);

    const [showCalls, setShowCalls] = useState(showCallOptions[1]);

    const [searchInputField, setSearchInputField] = useState({
        ...initialSearchData,
    });

    const selectedCallSourceRef = useRef({
        call_source_list_ref: [],
    });




    useEffect(() => {
        if (location) {
            let data = location.search.split('=')
            console.log("🚀 ~ file: SearchBar.js:246 ~ useEffect ~ data", data)
            if ("?callerId" === data[0]) {
                setSearchInputField((prevState) => {
                    return {
                        ...prevState,
                        caller_id: data[1]
                    }
                })
                SearchHandler(false, data[1], "", "")

            }
            else if ("?conversation_id" === data[0]) {
                setSearchInputField((prevState) => {
                    return {
                        ...prevState,
                        conversation_id: data[1]
                    }
                })
                SearchHandler(false, "", data[1], "")

            }
            else {
                if (componentIdentity === "callhistory" && initialSearchData.start_date === "" && initialSearchData.end_date === "") {
                    var date = new Date();
                    if (user?.oi_profile && user?.oi_profile?.toLowerCase() == "customer") {
                        initialSearchData.start_date = moment().tz("Australia/Sydney").format("YYYY-MM-DD");
                        initialSearchData.end_date = moment().tz("Australia/Sydney").format("YYYY-MM-DD");
                    } else {
                        date.setDate(date.getDate() - 30);
                        initialSearchData.start_date = moment(date).tz("Australia/Sydney").format("YYYY-MM-DD");
                        initialSearchData.end_date = moment().tz("Australia/Sydney").format("YYYY-MM-DD");
                    }
                } else if (componentIdentity === "trashcall" && initialSearchData.start_date === "" && initialSearchData.end_date === "") {
                    var date = new Date();
                    date.setDate(date.getDate() - 30);
                    initialSearchData.start_date = moment(date).tz("Australia/Sydney").format("YYYY-MM-DD");
                    initialSearchData.end_date = moment().tz("Australia/Sydney").format("YYYY-MM-DD");
                }
                else if (componentIdentity !== "callhistory" && componentIdentity !== "trashcall") {
                    initialSearchData.start_date = ""
                    initialSearchData.end_date = ""
                }
                setSearchInputField(initialSearchData)
                // initialSearchData is the initial search data
                SearchHandler(false, "", "", "", initialSearchData)
            }

        }

    }, [location])

    // const callDateTypeRef= useRef({
    //   selectedCallDateType:"CALL_DATE"
    // })

    const [callDateType, setCallDateType] = useState(callDateTypePriorities[0]);

    // const showCallSourceRef= useRef({
    //   showCallSource:"none"
    // })

    const [showCallSource, setCallSource] = useState("none");
    const [showCallContext, setCallContext] = useState("none");
    const [showCallStatusOptions, setShowCallStatusOptions] = useState("none");
    const [showUtteranceDropdown, setShowUtteranceDropdown] = useState("none");
    const [showConversationTag, setConversationTag] = useState("none");
    const [showConversationWorkflow, setConversationWorkflow] = useState("none");
    const [showCurrentStateFilter, setCurrentStateFilter] = useState("none");
    const [showCallDateTypeOptions, setShowCallDateTypeOptions] = useState("none");
    const [showModality, setModality] = useState("none");
    const [showCallStatus, setShowCallStatus] = useState(false);
    const [displayStatusList, setDisplayStatusList] = useState("none");

    const LogoutFunc = () => {
            logout({ returnTo: window.location.origin });
    };
    useEffect(() => {
        if (
            Array.isArray(operatorAssignedCenters) &&
            operatorAssignedCenters.length
        ) {
            let modifiedCenterList = [];
            for (let i = 0; i < operatorAssignedCenters.length; i++) {
                modifiedCenterList.push({
                    ...operatorAssignedCenters[i],
                    isChecked: false,
                });
            }
            setCenterList([...modifiedCenterList]);
        }
    }, [operatorAssignedCenters]);

    const [callSourceData, setCallSourceData] = useState([""]);

    const [centerSelectedData, setCenterSelectedData] = useState([""]);

    const [isRequestProcessing, setIsRequestProcessing] = useState(false);

     console.log("modalitiesList",modalitiesList)
     console.log("componentIdentity",componentIdentity)
     console.log("initialSearchData",initialSearchData)

    useEffect(() => {
        
      
    }, [])
    
     
    

    // setSearchInputField(initialSearchData)

    function handleData(data) {
        setCallContextList(data?.call_context_list)
        setStoredSelectedCallContextList(data?.call_context_list)
        setConversationTagList(data?.conversation_tag_list)
        setStoredSelectedConversationTagList(data?.conversation_tag_list)
        setModalitiesList(data?.modality_list)
        setStoredSelectedModalitiesList(data?.modality_list)
    }

    const searchInputHandler = (e) => {
        if (!e.target.value) {
            if (selectedCallContext?.length > 0) {
                //If there is any selected option then make it checked
                let filteredContextList = storedSelectedCallContextList?.map((item) => {
                    if (selectedCallContext.includes(item?.id)) {
                        return {
                            ...item,
                            isChecked: true,
                        };
                    }
                    return item;
                });

                setCallContextList([...filteredContextList]);
            } else {
                setCallContextList([...storedSelectedCallContextList]);
            }
        }
        else {
            let filteredData = storedSelectedCallContextList.filter(
                (item) =>
                    item.text
                        .toLowerCase()
                        .includes(e.target.value.trim().toLowerCase())
            );

            if (selectedCallContext?.length) {
                let filtered_data = filteredData.map((item) => {
                    if (selectedCallContext.includes(item?.id)) {
                        return {
                            ...item,
                            isChecked: true,
                        };
                    }
                    return item;
                });

                setCallContextList([...filtered_data]);
            } else {
                setCallContextList([...filteredData]);
            }
        }
    };

    const searchInputHandler2 = (e) => {
        if (!e.target.value) {
            if (selectedConversationTag?.length > 0) {
                //If there is any selected option then make it checked
                let filteredTagList = storedSelectedConversationTagList?.map((item) => {
                    if (selectedConversationTag.includes(item?.id)) {
                        return {
                            ...item,
                            isChecked: true,
                        };
                    }
                    return item;
                });

                setConversationTagList([...filteredTagList]);
            } else {
                setConversationTagList([...storedSelectedConversationTagList]);
            }
        }
        else {
            let filteredData = storedSelectedConversationTagList.filter(
                (item) =>
                    item.text
                        .toLowerCase()
                        .includes(e.target.value.trim().toLowerCase())
            );

            if (selectedConversationTag?.length) {
                let filtered_data = filteredData?.map((item) => {
                    if (selectedConversationTag.includes(item?.id)) {
                        return {
                            ...item,
                            isChecked: true,
                        };
                    }
                    return item;
                });

                setConversationTagList([...filtered_data]);
            } else {
                setConversationTagList([...filteredData]);
            }
        }
    };


    const searchInputHandler3 = (e) => {
        if (!e.target.value) {
            if (selectedCurrentStates?.length > 0) {
                //If there is any selected option then make it checked
                let filteredTagList = currentStateMaster?.map((item) => {
                    if (selectedCurrentStates.includes(item?.id)) {
                        return {
                            ...item,
                            isChecked: true,
                        };
                    }
                    return item;
                });

                setCurrentStateList([...filteredTagList]);
            } else {
                setCurrentStateList([...CURRENT_STATE_MASTER_DATA_SOURCE]);
            }
        }
        else {
            let filteredData = CURRENT_STATE_MASTER_DATA_SOURCE.filter(
                (item) =>
                    item.text
                        .toLowerCase()
                        .includes(e.target.value.trim().toLowerCase())
            );

            if (selectedCurrentStates?.length) {
                let filtered_data = filteredData?.map((item) => {
                    if (selectedCurrentStates.includes(item?.id)) {
                        return {
                            ...item,
                            isChecked: true,
                        };
                    }
                    return item;
                });

                setCurrentStateList([...filtered_data]);
            } else {
                setCurrentStateList([...filteredData]);
            }
        }
    };

    const searchInputHandler4 = (e) => {
        if (!e.target.value) {
            if (selectedModalitiesList?.length > 0) {
                //If there is any selected option then make it checked
                let filteredTagList = storedSelectedModalitiesList?.map((item) => {
                    if (selectedModalitiesList.includes(item?.modality_key)) {
                        return {
                            ...item,
                            isChecked: true,
                        };
                    }
                    return item;
                });

                setModalitiesList([...filteredTagList]);
            } else {
                setModalitiesList([...storedSelectedModalitiesList]);
            }
        }
        else {
            let filteredData = storedSelectedModalitiesList.filter(
                (item) =>
                    item?.modality_key
                        .toLowerCase()
                        .includes(e.target.value.trim().toLowerCase())
            );

            if (selectedModalitiesList?.length) {
                let filtered_data = filteredData?.map((item) => {
                    if (selectedModalitiesList.includes(item?.modality_key)) {
                        return {
                            ...item,
                            isChecked: true,
                        };
                    }
                    return item;
                });

                setModalitiesList([...filtered_data]);
            } else {
                setModalitiesList([...filteredData]);
            }
        }
    };


    // if (selectedModalitiesList?.length) {
    //     let filtered_data = filteredData.map((item) => {
    //         if (selectedModalitiesList.includes(item?.modality_key)) {
    //             return {
    //                 ...item,
    //                 isChecked: true,
    //             };
    //         }
    //         return item;
    //     });

    //     setModalitiesList([...filtered_data]);
    // } else {
    //     setModalitiesList([...filteredData]);
    // }





    const centerListToggle = () => {
        // setCallSourceListShow("none");
        // setDisplayStatusList("none");
        setShowCenterList((prevState) => !prevState);
        // setShowCallStatus(false);
    };
    

    const cneterSelectedNo = () => {
        return (
            <span style={{ fontSize: "15px", fontWeight: "600" }}>
                {selectedCenterIds.length} selected
            </span>
        );
    };

    const callStatusSelectedNo = () => {
        if (selectedCallStatus != null && selectedCallStatus.length !== 0) {
            return (
                <span style={{ fontSize: "15px", fontWeight: "600" }}>
                    {selectedCallStatus.length} selected
                </span>
            );
        }
    };

    const toggleFunc = () => {
        if (displayStatusList.length) {
            setDisplayStatusList("");
        } else {
            setDisplayStatusList("none");
        }
        setShowCenterList("none");
        setCallSource("none");
    };

    

    const errorHandler = (data) => {
        dispatch(
            SetError({
                ...data,
            })
        );
         if (data.error_code === 403) {
            setTimeout(() => {
                history.push("/expired");
            }, (3000));
        }
        errorDataHandler()
    };
    const dataHandler = (callData, isResetButtonClicked) => {
        console.log("🚀 ~ file: SearchBar.js:291 ~ dataHandler ~ callData", callData)
        const { data, totalCallCount, error_code, error_description, ErrorCode, ErrorDesc } = callData;
        callData.Loading=false
        if (ErrorCode) {
            dispatch(
                SetError({
                    severity: "warning",
                    message: ErrorDesc
                })
            );
            return
        }
        if (error_code) {
            dispatch(
                SetError({
                    severity: "warning",
                    message: error_description
                })
            );
            return
        }

        if (Array.isArray(data) && isResetButtonClicked) {
            callData.callStatusFilter = showCalls
            callDataHandler(callData);
        }
        if (Array.isArray(data) && !isResetButtonClicked) {
            callData.callStatusFilter = showCalls
            callData.utterance_filter_type = showUtteranceFilter.id
            callDataHandler(callData);
        }
    };

    // call_date_type
    const SearchHandler = async (isResetButtonClicked = false, caller_id = "", conversation_id = "", order_description = "") => {
        // NOTE:- hiding the drop down
        setShowCenterList("none");
        setCallSource("none");
        setDisplayStatusList("none");
        let searchData = initialSearchData;
        await setSearchInputField((prevState) => {
            searchData = prevState;
            return prevState
        })
        // NOTE:- clearing the conversation id and center details from the redux store
        dispatch(clearConversationIdFunc());
        dispatch(centerPreFixFunc(null));
        dispatch(centerSelectFunc(null));
        if(searchData==null){
            searchData = initialSearchData
        }
        if (searchData.utterance) {
            if (!searchData.start_date && !isResetButtonClicked) {
                dispatch(
                    SetError({
                        severity: "info",
                        message: "Please select From date",
                    })
                );
                return;
            }
            if (!searchData?.end_date && !isResetButtonClicked) {
                dispatch(
                    SetError({
                        severity: "info",
                        message: "Please select To date",
                    })
                );
                return;
            }
            if (!searchData?.end_date && !searchData.start_date && !isResetButtonClicked) {
                dispatch(
                    SetError({
                        severity: "info",
                        message: "Please select FROM and TO date",
                    })
                );
                return;
            }
            //  if (searchData?.end_date  != searchData.start_date ) {
            //     dispatch(
            //         SetError({
            //             severity: "info",
            //             message: "For utterance search, you can only load calls for one day. Please adjust the date range to one day.",
            //         })
            //     );
            //     return;
            // }
        }

        // NOTE:- validating form and to date , From date should not be greater than To date

        if (
            searchData?.end_date &&
            searchData?.start_date &&
            !isResetButtonClicked
        ) {
            let fromDate = new Date(searchData?.start_date);
            let toDate = new Date(searchData?.end_date);

            if (fromDate.getTime() <= toDate.getTime()) {
                // console.log("Correct Date range");
            } else {
                // console.log("Wrong Date");
                dispatch(
                    SetError({
                        severity: "warning",
                        message: "Your from date can not be greater than current date",
                    })
                );
                return;
            }
        }

        // NOTE:- if user selected a From date and To date did not select OR selected To date and From did not selected
        if (
            searchData?.start_date &&
            !searchData?.end_date &&
            !isResetButtonClicked
        ) {
            dispatch(
                SetError({
                    severity: "warning",
                    message: "Please select To date",
                })
            );
            return;
        }
        if (
            !searchData?.start_date &&
            searchData?.end_date &&
            !isResetButtonClicked
        ) {
            dispatch(
                SetError({
                    severity: "warning",
                    message: "Please select From date",
                })
            );
            return;
        }

        // NOTE:- Doing a validation , if callDateType id off (APPT_DATE)
        if (callDateType.name == callDateTypePriorities[1].name) {
            if (!searchData.start_date && !isResetButtonClicked) {
                dispatch(
                    SetError({
                        severity: "warning",
                        message: "Please select From date",
                    })
                );
                return;
            }
            if (!searchData?.end_date && !isResetButtonClicked) {
                dispatch(
                    SetError({
                        severity: "warning",
                        message: "Please select To date",
                    })
                );
                return;
            }
        }

        let url = `${GET_UNCONCLUDED_CALLS}?page_no=${page_no}`;
        let data = {
            ...searchData,
            end_date: searchData?.end_date
                ? moment(searchData?.end_date).format("YYYY-MM-DD")
                : "",
            start_date: searchData?.start_date
                ? moment(searchData?.start_date).format("YYYY-MM-DD")
                : "",
            dob: searchData?.dob
                ? moment(searchData?.dob).format("YYYY-MM-DD")
                : "",
            initiator_source: selectedCallSource,
            center_id: selectedCenterIds,
            operator_feedback: selectedCallStatus ? selectedCallStatus : [],
            date_search_by: callDateType.id,
            caller_id: searchData?.caller_id ? searchData?.caller_id : caller_id,
            conversation_id: searchData?.conversation_id ? searchData?.conversation_id.replace(/\s+/g, '') : conversation_id.replace(/\s+/g, ''),
            call_context: selectedCallContext,
            conversation_tag: selectedConversationTag,
            conversation_workflow_type: selectedConversationWorkflowType,
            last_known_conversation_states: selectedCurrentStates,
            utterance_filter_type: showUtteranceFilter.id,
            modality: selectedModalitiesList.join(","),
            order_description: searchData?.order_description ? searchData.order_description : order_description
            ,current_call_status: showCalls // Commenting out. We will get all calls from the backend. Call will only be filtered on UI.
        };

        if (isResetButtonClicked) {
            data = {
                ...initialSearchData,

                date_search_by: "CALL_DATE",
            };
        } else {
            if (searchData?.conversation_id ? searchData?.conversation_id : conversation_id && !isResetButtonClicked) {
                data = {
                    conversation_id: searchData?.conversation_id ? searchData?.conversation_id.replace(/\s+/g, '') : conversation_id.replace(/\s+/g, '')
                }
            }
        }
        onSearchClick(data);
        if (componentIdentity === "callhistory" || componentIdentity === "trashcall") {
            url = `${GET_ALL_CALLS}?page_no=${page_no}`;

            data["seach_query_for"] = componentIdentity;
        }
        callDataHandler({data:[],Loading:true})
        let showSuccessMessage = false;
        let token = await GetAuthToken();
        setShowUtteranceDropdown("none")
        postQueryHandler(
            url,
            data,
            setIsRequestProcessing,
            errorHandler,
            dataHandler,
            showSuccessMessage,
            isResetButtonClicked,
            errorDataHandler,
            token,
            LogoutFunc
        );
    };

    const resetHandler = () => {
        setSelectedConversationWorkflowType(() => []);
        setSelectedCurrentStates(() => []);
        setSelectedCallSource(() => []);
        setSelectedCenterIds(() => []);
        setSelectedCallStatus(() => []);
        onResetClick();

        // Resetting the selected call source option
        let sourceList = callSourceList?.map((item) => {
            return {
                ...item,
                isChecked: false,
            };
        });

        let _conversationWorkflowList = conversationWorkflowListMaster?.map((item) => {
            return {
                ...item,
                isChecked: false,
            };
        });


        let _currentStateMaster = currentStateMaster?.map((item) => {
            return {
                ...item,
                isChecked: false,
            };
        });

        let contextList = callContextList?.map((item) => {
            return {
                ...item,
                isChecked: false,
            };
        });

        let conversationList = conversationTagList?.map((item) => {
            return {
                ...item,
                isChecked: false,
            };
        });

        let modalityList = modalitiesList?.map((item) => {
            return {
                ...item,
                isChecked: false,
            };
        });

        setConversationWorkflowListMaster(() => [..._conversationWorkflowList]);
        setCurrentStateMaster(() => [..._currentStateMaster]);
        setCallSourceList(() => [...sourceList]);
        setCallContextList(() => [...contextList]);
        setConversationTagList(() => [...conversationList]);
        setModalitiesList(() => [...modalityList])
        setCurrentStateList(() => [...CURRENT_STATE_MASTER_DATA_SOURCE]);

        setSelectedConversationWorkflowType(() => []);
        setSelectedCurrentStates(() => []);
        setSelectedCallSource(() => []);
        setSelectedCallContext(() => []);
        setSelectedConversationTag(() => []);
        setSelectedModalitiesList(() => []);

        setShowCenterList("none");
        setCallSource("none");
        setCallContext("none");
        setConversationTag("none");
        setShowCallStatusOptions("none");
        setShowCallDateTypeOptions("none");
        setDisplayStatusList("none");
        setModality("none");
        setCallDateType(callDateTypePriorities[0]);
        SearchHandler(true);
        setShowUtteranceFilter(showUtteranceFilterOptions[0])

        if (componentIdentity == "callhistory" || componentIdentity == "trashcall") {
            let date = new Date();
            let default_start_date = moment().tz("Australia/Sydney").format("YYYY-MM-DD");
            let default_end_date = moment().tz("Australia/Sydney").format("YYYY-MM-DD");

            if (user?.oi_profile && user?.oi_profile?.toLowerCase() == "customer") {
                default_start_date = moment().tz("Australia/Sydney").format("YYYY-MM-DD");
                default_end_date = moment().tz("Australia/Sydney").format("YYYY-MM-DD");
            } else {
                date.setDate(date.getDate() - 30);
                default_start_date = moment(date).tz("Australia/Sydney").format("YYYY-MM-DD");
                default_end_date = moment().tz("Australia/Sydney").format("YYYY-MM-DD");
            }
            setSearchInputField((prev) => { return { ...prev, conversation_id: "", start_date: default_start_date, end_date: default_end_date, caller_id: "" } })
        } else {
            setSearchInputField((prev) => { return { ...prev, conversation_id: "", start_date: "", end_date: "", caller_id: "" } })
        }

    };









    const InputHandler = (e) => {

        setSearchInputField((prevState) => {
            return {
                ...prevState,
                [e.target.name]: e.target.value
            }
        })
        console.log("Event", e.target.value, e.target.name)
    };

    const dobChangeHandler = (value) => {
        setSearchInputField((prevState) => {
            return {
                ...prevState,
                dob: value
            }
        })
    };


    return (
        <div className={styles.container}>
            <InputContainer>
                <InputGroup>
                    {user?.oi_profile && user?.oi_profile?.toLowerCase() !== "customer" &&
                        <>
                            <InputFieldWithTitle
                                name={"first_name"}
                                value={searchInputField.first_name}
                                InputHandler={InputHandler}
                                title={"FName"}
                                type={"text"}
                                customCss={{ width: "120px" }}
                            />
                            <InputFieldWithTitle
                                name={"last_name"}
                                value={searchInputField.last_name}
                                InputHandler={InputHandler}
                                title={"LName"}
                                type={"text"}
                                customCss={{ width: "120px" }}
                            />
                            <DOBContainer>
                                <label style={{ marginRight: "6px" }}>DOB</label>
                                <DatePicker
                                    onChange={dobChangeHandler}
                                    value={searchInputField.dob}
                                    disableCalendar={true}
                                    format="dd/MM/y"
                                    clearIcon={true}
                                    dayPlaceholder="DD"
                                    monthPlaceholder="MM"
                                    yearPlaceholder="YYYY"
                                />
                            </DOBContainer>
                        </>
                    }
                    <InputFieldWithTitle
                        name={"caller_id"}
                        value={searchInputField.caller_id}
                        InputHandler={InputHandler}
                        title={"PH#"}
                        type={"text"}
                        customCss={{ width: "150px" }}
                    />
                    <VerticalLine></VerticalLine>
                    <div>
                        <div style={{ display: "flex" }}>
                            <InputFieldWithTitle
                                name={"start_date"}
                                value={searchInputField.start_date}
                                InputHandler={InputHandler}
                                title={"FROM"}
                                type={"date"}
                            />
                            <InputFieldWithTitle
                                name={"end_date"}
                                value={searchInputField.end_date}
                                InputHandler={InputHandler}
                                title={"TO"}
                                type={"date"}
                            />
                        </div>
                        {user?.oi_profile && user?.oi_profile?.toLowerCase() == "customer" && <div style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)" }}>
                            <div></div>
                            <div className={styles?.date_filter_shortcut}>
                                <div onClick={() => {
                                    setSearchInputField((prevState) => {
                                        return {
                                            ...prevState,
                                            "start_date": moment().subtract(1, 'day').format('YYYY-MM-DD'),
                                            "end_date": moment().subtract(1, 'day').format('YYYY-MM-DD')
                                        }
                                    })
                                }}
                                    style={searchInputField.end_date == moment().subtract(1, 'day').format('YYYY-MM-DD') ? { color: "green", textDecoration: "underline" } : {}}
                                >Yesterday</div>
                                <div onClick={() => {
                                    setSearchInputField((prevState) => {
                                        return {
                                            ...prevState,
                                            "start_date": moment().format('YYYY-MM-DD'),
                                            "end_date": moment().format('YYYY-MM-DD')
                                        }
                                    })
                                }}
                                    style={searchInputField.start_date == moment().format('YYYY-MM-DD') ? { color: "green", textDecoration: "underline" } : {}}
                                > Today</div>
                            </div>
                        </div>
                        }
                    </div>


                    {/* <SwitchContainer>
                        <Switch
                            width={"120"}
                            switchedOffText={callDateTypePriorities[1]}
                            switchedOnText={callDateTypePriorities[0]}
                            value={callDateType}
                            onValueChange={(e) => {
                                setCallDateType(e);

                                console.log(e);
                            }}
                        />
                    </SwitchContainer> */}
                    <div
                        className={styles?.call_context_container}
                        style={{ marginTop: "12px" }}
                    >
                        <div
                            style={{
                                borderBottom: "1px solid lightgrey",
                                position: "relative",
                                marginRight: "15px",
                                cursor: "pointer",
                            }}
                        >
                            <div
                                style={{
                                    // fontWeight: "550",
                                    color: "#586C72",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                }}
                                onClick={() => {
                                    if (showCallDateTypeOptions?.length) {
                                        setShowCallDateTypeOptions("");
                                    } else {
                                        setShowCallDateTypeOptions("none");
                                    }
                                    setCallContext("none");
                                    setShowCenterList("none");
                                    setModality("none");
                                    setDisplayStatusList("none");
                                }}
                            >
                                <span> {callDateType.name.toUpperCase()} </span>
                                <span style={{ marginLeft: "5px" }}>
                                    <ArrowDropDownIcon />
                                </span>
                            </div>

                            <CallSourceDropDownContainer
                                style={{ display: showCallDateTypeOptions }}
                            >
                                <CallSourceDropDown>
                                    <div className="modal-box" >
                                        <div
                                            className="centerList"
                                            style={{ position: "relative", height: "50%", width: "200px", border: "1px solid gray", padding: "5px" }}
                                        >
                                            {callDateTypePriorities.map((call_date_type) => {
                                                return <div onClick={() => {
                                                    setCallDateType(call_date_type);
                                                    if (showCallDateTypeOptions?.length) {
                                                        setShowCallDateTypeOptions("");
                                                    } else {
                                                        setShowCallDateTypeOptions("none");
                                                    }
                                                }} style={{ padding: "5px" }}>{call_date_type.name.toLowerCase().replace(/\b\w/g, char => char.toUpperCase())}</div>
                                            })}
                                        </div>

                                    </div>
                                </CallSourceDropDown>
                            </CallSourceDropDownContainer>
                        </div>
                    </div>
                    <VerticalLine></VerticalLine>

                    <div style={{ position: "relative", marginTop: "12px" }}>
                        <CenterDropDown
                            className="search "
                            id="centerlist"
                            onClick={() => {
                                if (showCenterList.length) {
                                    setShowCenterList("");
                                } else {
                                    setShowCenterList("none");
                                }
                                setModality("none");
                                setCallSource("none");
                                setDisplayStatusList("none");
                            }}
                        >
                            <span>
                                {selectedCenterIds?.length !== 0
                                    ? cneterSelectedNo()
                                    : "CENTER"}
                            </span>

                            <span style={{ marginLeft: "5px" }}>
                                <ArrowDropDownIcon />
                            </span>
                        </CenterDropDown>
                        <div
                            style={{
                                position: "absolute",
                                top: "30px",
                                zIndex: "1000",
                                width: "250px",
                                display: showCenterList,
                            }}
                        >
                            <Centerlist
                                center_list={centerList}
                                closeModal={centerListToggle}
                                centerListArr={[]}
                                showCenterList={showCenterList}
                                setShowCenterList={(val) => setShowCenterList(val)}
                                selectedCenterIdsHandler={setSelectedCenterIds}
                                selectedCenterIdsList={selectedCenterIds}
                            />
                        </div>
                    </div>
                    {user?.oi_profile && user?.oi_profile?.toLowerCase() !== "customer" &&
                        <div
                            className={styles.call_status_container}
                            style={{ width: "200px", position: "relative", marginTop: "12px", zIndex: 100 }}
                        >
                            <div>
                                <StatusCodeDropdown onClick={toggleFunc}>
                                    <span>
                                        {selectedCallStatus != null && selectedCallStatus.length != 0
                                            ? callStatusSelectedNo()
                                            : "CALL STATUS"}
                                    </span>
                                    <span style={{ marginLeft: "5px" }}>
                                        <ArrowDropDownIcon />
                                    </span>
                                </StatusCodeDropdown>

                                <CallStatusDropDownContainer
                                    className="callstatuslist"
                                    style={{

                                        display: displayStatusList,
                                    }}
                                >
                                    <StatusCodeList
                                        closeModal={toggleFunc}
                                        onData={handleData}
                                        showCallStatus={showCallStatus}
                                        setShowCallStatus={(val) => setShowCallStatus(val)}
                                        displayStatusList={displayStatusList}
                                        setCallStatusList={(val) => setCallStatusList(val)}
                                        resetClick={resetClick}
                                        selectedCallStatusHandler={setSelectedCallStatus}
                                        selectedCallStatus={selectedCallStatus}
                                    />
                                </CallStatusDropDownContainer>
                            </div>
                        </div>
                    }
                    <InputFieldWithTitle
                        name={"conversation_id"}
                        value={searchInputField.conversation_id}
                        InputHandler={InputHandler}
                        title={"CONV#"}
                        type={"text"}
                        customCss={{ width: "220px" }}
                    />
                    {/* call source multiselect box */}
                    {user?.oi_profile && user?.oi_profile?.toLowerCase() !== "customer" &&
                        <>
                            <div
                                className={styles.call_source_container}
                                style={{ marginTop: "12px" }}
                            >
                                <div
                                    style={{
                                        borderBottom: "1px solid lightgrey",
                                        position: "relative",
                                        marginRight: "15px",
                                        cursor: "pointer",
                                    }}
                                >
                                    <div
                                        style={{
                                            // fontWeight: "550",
                                            color: "#586C72",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                        }}
                                        onClick={() => {
                                            if (showCallSource.length) {
                                                setCallSource("");
                                            } else {
                                                setCallSource("none");
                                            }
                                            setShowCenterList("none");
                                            setModality("none");
                                            setDisplayStatusList("none");
                                        }}
                                    >
                                        {selectedCallSource.length == 0 ? (
                                            <span>CALL SOURCE</span>
                                        ) : (
                                            <span> {selectedCallSource.length} Selected </span>
                                        )}
                                        <span style={{ marginLeft: "5px" }}>
                                            <ArrowDropDownIcon />
                                        </span>
                                    </div>

                                    <CallSourceDropDownContainer
                                        // className="filterbar__callsource"
                                        style={{ display: showCallSource }}
                                    >
                                        <CallSourceDropDown>

                                            {callSourceList?.map((item, index) => (
                                                <div className="filterbar__dropdown" key={item.id} style={{ marginLeft: index == 2 || index == 3 || index == 4 || index == 1 ? "14%" : "0%", marginTop: index == 2 || index == 3 || index == 4 || index == 1 ? "-10px" : "10px" }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={item.isChecked}
                                                        style={{ marginRight: "5px", marginLeft: "10px" }}
                                                        onChange={() => {
                                                            let callSourceIds = selectedCallSource;
                                                            let sourceList = callSourceList;
                                                            let idx = sourceList.findIndex(
                                                                (each) => each.id === item.id
                                                            );
                                                            let data = sourceList[idx];
                                                            if (item.id == "VOICE_CALL") {
                                                                if (sourceList[idx].isChecked) {
                                                                    data = {
                                                                        ...data,
                                                                        isChecked: false,
                                                                    };
                                                                    if (sourceList[1].isChecked) {
                                                                        sourceList[1].isChecked = false;
                                                                        callSourceIds = callSourceIds.filter(
                                                                            (id) => id !== sourceList[1].id
                                                                        );
                                                                    }
                                                                    if (sourceList[2].isChecked) {
                                                                        sourceList[2].isChecked = false;
                                                                        callSourceIds = callSourceIds.filter(
                                                                            (id) => id !== sourceList[2].id
                                                                        );
                                                                    }
                                                                    if (sourceList[3].isChecked) {
                                                                        sourceList[3].isChecked = false;
                                                                        callSourceIds = callSourceIds.filter(
                                                                            (id) => id !== sourceList[3].id
                                                                        );
                                                                    }
                                                                    if (sourceList[4].isChecked) {
                                                                        sourceList[4].isChecked = false;
                                                                        callSourceIds = callSourceIds.filter(
                                                                            (id) => id !== sourceList[4].id
                                                                        );
                                                                    }
                                                                } else {
                                                                    data = {
                                                                        ...data,
                                                                        isChecked: true,
                                                                    };
                                                                    if (!sourceList[1].isChecked) { sourceList[1].isChecked = true; callSourceIds.push(sourceList[1].id); }
                                                                    if (!sourceList[2].isChecked) { sourceList[2].isChecked = true; callSourceIds.push(sourceList[2].id); }
                                                                    if (!sourceList[3].isChecked) { sourceList[3].isChecked = true; callSourceIds.push(sourceList[3].id); }
                                                                    if (!sourceList[4].isChecked) { sourceList[4].isChecked = true; callSourceIds.push(sourceList[4].id); }
                                                                }
                                                            } else {
                                                                if (sourceList[idx].isChecked) {
                                                                    data = {
                                                                        ...data,
                                                                        isChecked: false,
                                                                    };

                                                                    callSourceIds = callSourceIds.filter(
                                                                        (id) => id !== item.id
                                                                    );
                                                                    if (idx == 1 || idx == 2 || idx == 3 || idx == 4) {
                                                                        sourceList[0].isChecked = false
                                                                    }

                                                                } else {
                                                                    data = {
                                                                        ...data,
                                                                        isChecked: true,
                                                                    };
                                                                    callSourceIds.push(item.id);
                                                                    if (idx == 1 || idx == 2 || idx == 3 || idx == 4) {
                                                                        let source_selected_count = 0
                                                                        if (sourceList[1].isChecked) { source_selected_count++; }
                                                                        if (sourceList[2].isChecked) { source_selected_count++; }
                                                                        if (sourceList[3].isChecked) { source_selected_count++; }
                                                                        if (sourceList[4].isChecked) { source_selected_count++; }
                                                                        if (source_selected_count == 3) {
                                                                            sourceList[0].isChecked = true
                                                                        }
                                                                    }
                                                                }
                                                            }

                                                            sourceList[idx] = data;

                                                            setCallSourceList(() => [...sourceList]);
                                                            setSelectedCallSource(() => [...callSourceIds]);
                                                            console.log([...callSourceIds])
                                                            // selectedCallSourceRef.current.call_source_list_ref=selectedCallSource
                                                        }}
                                                    // onChange={(e) => callSourceCheckHandler(e, item.id)}
                                                    />
                                                    <span style={{ fontSize: "15px" }}>{item.text}</span>
                                                </div>
                                            ))}
                                            <center
                                                className="filterbar__callSource__done"
                                                onClick={() => {
                                                    if (showCallSource.length) {
                                                        setCallSource("");
                                                    } else {
                                                        setCallSource("none");
                                                    }
                                                }}
                                            >
                                                Done
                                            </center>
                                        </CallSourceDropDown>

                                    </CallSourceDropDownContainer>




                                </div>

                            </div>

                            {/* // call context multiselect box */}
                            <div
                                className={styles?.call_context_container}
                                style={{ marginTop: "12px" }}
                            >
                                <div
                                    style={{
                                        borderBottom: "1px solid lightgrey",
                                        position: "relative",
                                        marginRight: "15px",
                                        cursor: "pointer",
                                    }}
                                >
                                    <div
                                        style={{
                                            // fontWeight: "550",
                                            color: "#586C72",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                        }}
                                        onClick={() => {
                                            if (showCallContext?.length) {
                                                setCallContext("");
                                            } else {
                                                setCallContext("none");
                                            }
                                            setShowCenterList("none");
                                            setModality("none");
                                            setDisplayStatusList("none");
                                        }}
                                    >
                                        {selectedCallContext?.length == 0 ? (
                                            <span>CALL CONTEXT</span>
                                        ) : (
                                            <span> {selectedCallContext?.length} Selected </span>
                                        )}
                                        <span style={{ marginLeft: "5px" }}>
                                            <ArrowDropDownIcon />
                                        </span>
                                    </div>

                                    <CallSourceDropDownContainer
                                        style={{ display: showCallContext }}
                                    >
                                        <CallSourceDropDown>
                                            <div className="modal-box" >
                                                <div
                                                    className="centerList"
                                                    style={{ borderBottom: "none", position: "relative" }}
                                                >
                                                    <SearchInputContainer>
                                                        <SearchInput
                                                            placeholder="Search Context.."
                                                            onChange={searchInputHandler}
                                                        />
                                                    </SearchInputContainer>

                                                    {callContextList?.map((item, index) => (
                                                        <div className="filterbar__dropdown" key={item?.id}>
                                                            <input
                                                                type="checkbox"
                                                                checked={item?.isChecked}
                                                                style={{ marginRight: "5px", marginLeft: "10px" }}
                                                                onChange={() => {
                                                                    let callContextIds = selectedCallContext;
                                                                    let contextList = callContextList;
                                                                    let idx = contextList.findIndex(
                                                                        (each) => each?.id === item?.id
                                                                    );
                                                                    let data = contextList[idx];
                                                                    if (contextList[idx]?.isChecked) {
                                                                        data = {
                                                                            ...data,
                                                                            isChecked: false,
                                                                        };
                                                                        callContextIds = callContextIds?.filter(
                                                                            (id) => id !== item.id
                                                                        );
                                                                    } else {
                                                                        data = {
                                                                            ...data,
                                                                            isChecked: true,
                                                                        };
                                                                        callContextIds.push(item?.id);
                                                                    }
                                                                    contextList[idx] = data;

                                                                    setCallContextList(() => [...contextList]);
                                                                    setSelectedCallContext(() => [...callContextIds]);
                                                                }}
                                                            />
                                                            <span style={{ fontSize: "15px" }}>{item?.text}</span>
                                                        </div>
                                                    ))}


                                                </div>
                                                <div
                                                    className="modalCloseBtn" style={{ width: '250px' }}
                                                    onClick={() => {
                                                        if (showCallContext?.length) {
                                                            setCallContext("");
                                                        } else {
                                                            setCallContext("none");
                                                        }
                                                    }}
                                                >
                                                    Done
                                                </div>

                                            </div>
                                        </CallSourceDropDown>

                                    </CallSourceDropDownContainer>
                                </div>
                            </div>

                            {/* conversation tag multiselect box */}


                            {user?.oi_profile && user?.oi_profile?.toLowerCase() !== "customer" &&
                                <div
                                    className={styles?.conversation_tag_container}
                                    style={{ marginTop: "12px" }}
                                >
                                    <div
                                        style={{
                                            borderBottom: "1px solid lightgrey",
                                            position: "relative",
                                            marginRight: "15px",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <div
                                            style={{
                                                // fontWeight: "550",
                                                color: "#586C72",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                            }}
                                            onClick={() => {
                                                if (showConversationTag?.length) {
                                                    setConversationTag("");
                                                } else {
                                                    setConversationTag("none");
                                                }
                                                setShowCenterList("none");
                                                setModality("none");
                                                setDisplayStatusList("none");
                                            }}
                                        >
                                            {selectedConversationTag?.length == 0 ? (
                                                <span>CALL TAGS</span>
                                            ) : (
                                                <span> {selectedConversationTag?.length} Selected </span>
                                            )}
                                            <span style={{ marginLeft: "5px" }}>
                                                <ArrowDropDownIcon />
                                            </span>
                                        </div>

                                        <CallSourceDropDownContainer
                                            // className="filterbar__callsource"
                                            style={{ display: showConversationTag }}
                                        >
                                            <CallSourceDropDown>
                                                <div className="modal-box" >
                                                    <div
                                                        className="centerList"
                                                        style={{ borderBottom: "none", position: "relative" }}
                                                    >
                                                        <SearchInputContainer>
                                                            <SearchInput
                                                                placeholder="Search Conversation Tags.."
                                                                onChange={searchInputHandler2}
                                                            />
                                                        </SearchInputContainer>
                                                        {conversationTagList?.map((item, index) => (
                                                            <div className="filterbar__dropdown" key={item?.id}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={item?.isChecked}
                                                                    style={{ marginRight: "5px", marginLeft: "10px" }}
                                                                    onChange={() => {
                                                                        let conversationTagIds = selectedConversationTag;
                                                                        let conversationList = conversationTagList;
                                                                        let idx = conversationList.findIndex(
                                                                            (each) => each?.id === item?.id
                                                                        );
                                                                        let data = conversationList[idx];
                                                                        if (conversationList[idx]?.isChecked) {
                                                                            data = {
                                                                                ...data,
                                                                                isChecked: false,
                                                                            };
                                                                            conversationTagIds = conversationTagIds?.filter(
                                                                                (id) => id !== item?.id
                                                                            );
                                                                        }
                                                                        else {
                                                                            data = {
                                                                                ...data,
                                                                                isChecked: true,
                                                                            };
                                                                            conversationTagIds.push(item?.id);
                                                                        }
                                                                        conversationList[idx] = data;

                                                                        setConversationTagList(() => [...conversationList]);
                                                                        setSelectedConversationTag(() => [...conversationTagIds]);
                                                                        // selectedCallSourceRef.current.call_source_list_ref=selectedCallSource
                                                                    }}
                                                                // onChange={(e) => callSourceCheckHandler(e, item.id)}
                                                                />
                                                                <span style={{ fontSize: "15px" }}>{item?.text}</span>
                                                            </div>
                                                        ))}

                                                    </div>
                                                    <div
                                                        className="modalCloseBtn" style={{ width: '250px' }}
                                                        onClick={() => {
                                                            if (showConversationTag?.length) {
                                                                setConversationTag("");
                                                            } else {
                                                                setConversationTag("none");
                                                            }
                                                        }}
                                                    >
                                                        Done
                                                    </div>

                                                </div>
                                            </CallSourceDropDown>

                                        </CallSourceDropDownContainer>
                                    </div>
                                </div>
                            }


                        </>
                    }
                    {/* conversation workflow multiselect box */}
                    {componentIdentity === "callhistory" && user?.oi_profile && user?.oi_profile?.toLowerCase() !== "customer" && <>
                        <div
                            className={styles?.conversation_tag_container}
                            style={{ marginTop: "12px" }}
                        >
                            <div
                                style={{
                                    borderBottom: "1px solid lightgrey",
                                    position: "relative",
                                    marginRight: "15px",
                                    cursor: "pointer",
                                }}
                            >
                                <div
                                    style={{
                                        // fontWeight: "550",
                                        color: "#586C72",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                    }}
                                    onClick={() => {
                                        if (showConversationWorkflow?.length) {
                                            setConversationWorkflow("");
                                        } else {
                                            setConversationWorkflow("none")
                                        }
                                        setConversationTag("none");
                                        setShowCenterList("none");
                                        setModality("none");
                                        setDisplayStatusList("none");
                                    }}
                                >
                                    {selectedConversationWorkflowType?.length == 0 ? (
                                        <span>WORKFLOW</span>
                                    ) : (
                                        <span> {selectedConversationWorkflowType?.length} Selected </span>
                                    )}
                                    <span style={{ marginLeft: "5px" }}>
                                        <ArrowDropDownIcon />
                                    </span>
                                </div>
                                <CallSourceDropDownContainer
                                    // className="filterbar__callsource"
                                    style={{ display: showConversationWorkflow }}
                                >
                                    <CallSourceDropDown>
                                        <div className="modal-box" >
                                            <div
                                                className="centerList"
                                                style={{ borderBottom: "none", position: "relative" }}
                                            >
                                                {conversationWorkflowListMaster?.map((item, index) => (
                                                    <div className="filterbar__dropdown" key={item?.id}>
                                                        <input
                                                            type="checkbox"
                                                            checked={item?.isChecked}
                                                            style={{ marginRight: "5px", marginLeft: "10px" }}
                                                            onChange={() => {
                                                                let conversationWorkFlowIds = selectedConversationWorkflowType;
                                                                let conversationWorkflowList = conversationWorkflowListMaster;
                                                                let idx = conversationWorkflowList.findIndex(
                                                                    (each) => each?.id === item?.id
                                                                );
                                                                let data = conversationWorkflowList[idx];
                                                                if (conversationWorkflowList[idx]?.isChecked) {
                                                                    data = {
                                                                        ...data,
                                                                        isChecked: false,
                                                                    };
                                                                    conversationWorkFlowIds = conversationWorkFlowIds?.filter(
                                                                        (id) => id !== item?.id
                                                                    );
                                                                }
                                                                else {
                                                                    data = {
                                                                        ...data,
                                                                        isChecked: true,
                                                                    };
                                                                    conversationWorkFlowIds.push(item?.id);
                                                                }
                                                                conversationWorkflowList[idx] = data;

                                                                // setConversationTagList(() => [...conversationList]);
                                                                setSelectedConversationWorkflowType(() => [...conversationWorkFlowIds]);
                                                                // selectedCallSourceRef.current.call_source_list_ref=selectedCallSource
                                                            }}
                                                        // onChange={(e) => callSourceCheckHandler(e, item.id)}
                                                        />
                                                        <span style={{ fontSize: "15px" }}>{item?.text}</span>
                                                    </div>
                                                ))}
                                            </div>
                                            <div
                                                className="modalCloseBtn" style={{ width: '250px' }}
                                                onClick={() => {
                                                    if (showConversationWorkflow?.length) {
                                                        setConversationWorkflow("");
                                                    } else {
                                                        setConversationWorkflow("none");
                                                    }
                                                }}
                                            >
                                                Done
                                            </div>
                                        </div>
                                    </CallSourceDropDown>
                                </CallSourceDropDownContainer>
                            </div>
                        </div>
                        {user?.oi_profile && user?.oi_profile?.toLowerCase() !== "customer" &&
                            <div
                                className={styles?.conversation_tag_container}
                                style={{ marginTop: "12px" }}
                            >
                                <div
                                    style={{
                                        borderBottom: "1px solid lightgrey",
                                        position: "relative",
                                        marginRight: "15px",
                                        cursor: "pointer",
                                    }}
                                >
                                    <div
                                        style={{
                                            // fontWeight: "550",
                                            color: "#586C72",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                        }}
                                        onClick={() => {
                                            if (showCurrentStateFilter?.length) {
                                                setCurrentStateFilter("");
                                            } else {
                                                setCurrentStateFilter("none")
                                            }
                                            setConversationTag("none");
                                            setShowCenterList("none");
                                            setModality("none");
                                            setDisplayStatusList("none");
                                        }}
                                    >
                                        {selectedCurrentStates?.length == 0 ? (
                                            <span>Current State</span>
                                        ) : (
                                            <span> {selectedCurrentStates?.length} Selected </span>
                                        )}
                                        <span style={{ marginLeft: "5px" }}>
                                            <ArrowDropDownIcon />
                                        </span>
                                    </div>
                                    {user?.oi_profile && user?.oi_profile?.toLowerCase() !== "customer" && <CallSourceDropDownContainer
                                        // className="filterbar__callsource"
                                        style={{ display: showCurrentStateFilter }}
                                    >
                                        <CallSourceDropDown>
                                            <div className="modal-box" style={{ width: "100%" }}>
                                                <div
                                                    className="centerList"
                                                    style={{ borderBottom: "none", position: "relative", width: "fit-content" }}
                                                >
                                                    {/* <SearchInputContainer>
                                                <SearchInput
                                                    placeholder="Search..."
                                                    onChange={searchInputHandler3}
                                                />
                                            </SearchInputContainer> */}
                                                    {currentStateMaster?.map((item, index) => (
                                                        <div className="filterbar__dropdown" key={item?.id}>
                                                            <input
                                                                type="checkbox"
                                                                checked={item?.isChecked}
                                                                style={{ marginRight: "5px", marginLeft: "10px" }}
                                                                onChange={() => {
                                                                    let currentStateIds = selectedCurrentStates;
                                                                    let currentStateList = currentStateMaster;
                                                                    let idx = currentStateList.findIndex(
                                                                        (each) => each?.id === item?.id
                                                                    );
                                                                    let data = currentStateList[idx];
                                                                    if (currentStateList[idx]?.isChecked) {
                                                                        data = {
                                                                            ...data,
                                                                            isChecked: false,
                                                                        };
                                                                        currentStateIds = currentStateIds?.filter(
                                                                            (id) => id !== item?.id
                                                                        );
                                                                    }
                                                                    else {
                                                                        data = {
                                                                            ...data,
                                                                            isChecked: true,
                                                                        };
                                                                        currentStateIds.push(item?.id);
                                                                    }
                                                                    currentStateList[idx] = data;

                                                                    // setCurrentStateList(() => [...currentStateList]);
                                                                    setSelectedCurrentStates(() => [...currentStateIds]);
                                                                    // selectedCallSourceRef.current.call_source_list_ref=selectedCallSource
                                                                }}
                                                            // onChange={(e) => callSourceCheckHandler(e, item.id)}
                                                            />
                                                            <span style={{ fontSize: "15px" }}>{item?.text}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                                <div
                                                    className="modalCloseBtn" style={{ width: '300%' }}
                                                    onClick={() => {
                                                        if (showCurrentStateFilter?.length) {
                                                            setCurrentStateFilter("");
                                                        } else {
                                                            setCurrentStateFilter("none");
                                                        }
                                                    }}
                                                >
                                                    Done
                                                </div>
                                            </div>
                                        </CallSourceDropDown>
                                    </CallSourceDropDownContainer>
                                    }
                                </div>
                            </div>
                        }
                    </>
                    }
                    {/* ---------UTTERANCE Search------------------- */}
                    <div style={{ marginRight: "20px",display:!user?.can_search_utterance && "none"}}>
                        {componentIdentity === "callhistory" &&
                            user?.oi_profile && user?.oi_profile?.toLowerCase() === "internal" && (
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <VerticalLine></VerticalLine>
                                    <InputFieldWithTitle
                                        name={"utterance"}
                                        value={searchInputField.utterance}
                                        InputHandler={InputHandler}
                                        title={"UTTERANCE"}
                                        type={"text"}
                                    />
                                    <div
                                        className={styles?.call_context_container}
                                        style={{ marginTop: "5px" }}
                                    >
                                        <div
                                            style={{
                                                borderBottom: "1px solid lightgrey",
                                                position: "relative",
                                                marginRight: "15px",
                                                cursor: "pointer",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    // fontWeight: "550",
                                                    color: "#586C72",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                }}
                                                onClick={() => {
                                                    if (showUtteranceDropdown?.length) {
                                                        setShowUtteranceDropdown("");
                                                    } else {
                                                        setShowUtteranceDropdown("none");
                                                    }
                                                    setCallContext("none");
                                                    setModality("none");
                                                    setShowCenterList("none");
                                                    setDisplayStatusList("none");
                                                }}
                                            >
                                                <span> {showUtteranceFilter.name} </span>
                                                <span style={{ marginLeft: "5px" }}>
                                                    <ArrowDropDownIcon />
                                                </span>
                                            </div>

                                            <UttranceDropDownContainer
                                                style={{ display: showUtteranceDropdown }}
                                            >
                                                <UtteranceSourceDropDown>
                                                    <div className="modal-box" >
                                                        <div
                                                            className="centerList"
                                                            style={{ position: "relative", height: "50%", width: "200px", border: "1px solid gray", padding: "5px" }}
                                                        >
                                                            {showUtteranceFilterOptions.map((utterance_option) => {
                                                                return <div onClick={() => {
                                                                    setShowUtteranceFilter(utterance_option)
                                                                    if (showUtteranceDropdown?.length) {
                                                                        setShowUtteranceDropdown("");
                                                                    } else {
                                                                        setShowUtteranceDropdown("none");
                                                                    }
                                                                }} style={{ padding: "5px" }}>{utterance_option.name.toLowerCase().replace(/\b\w/g, char => char.toUpperCase())}</div>
                                                            })}
                                                        </div>

                                                    </div>
                                                </UtteranceSourceDropDown>
                                            </UttranceDropDownContainer>
                                        </div>
                                    </div>
                                    <VerticalLine></VerticalLine>
                                </div>

                            )}

                    </div>


                    {/* call context multiselect box */}

                    {componentIdentity === "workdesk" && user?.oi_profile && user?.oi_profile?.toLowerCase() !== "customer" &&
                        <div
                            className={styles?.call_context_container}
                            style={{ marginTop: "12px" }}
                        >
                            <div
                                style={{
                                    borderBottom: "1px solid lightgrey",
                                    position: "relative",
                                    marginRight: "15px",
                                    cursor: "pointer",
                                }}
                            >
                                <div
                                    style={{
                                        // fontWeight: "550",
                                        color: "#586C72",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                    }}
                                    onClick={() => {
                                        if (showCallStatusOptions?.length) {
                                            setShowCallStatusOptions("");
                                        } else {
                                            setShowCallStatusOptions("none");
                                        }
                                        setCallContext("none");
                                        setShowCenterList("none");
                                        setModality("none");
                                        setDisplayStatusList("none");
                                    }}
                                >
                                    <span> {showCalls} </span>
                                    <span style={{ marginLeft: "5px" }}>
                                        <ArrowDropDownIcon />
                                    </span>
                                </div>

                                <CallSourceDropDownContainer
                                    style={{ display: showCallStatusOptions }}
                                >
                                    <CallSourceDropDown>
                                        <div className="modal-box" >
                                            <div
                                                className="centerList"
                                                style={{ position: "relative", height: "50%", width: "200px", border: "1px solid gray", padding: "5px" }}
                                            >
                                                {showCallOptions.map((call_option) => {
                                                    return <div onClick={() => {
                                                        setShowCalls(call_option)
                                                        if (showCallStatusOptions?.length) {
                                                            setShowCallStatusOptions("");
                                                        } else {
                                                            setShowCallStatusOptions("none");
                                                        }
                                                    }} style={{ padding: "5px" }}>{call_option.toLowerCase().replace(/\b\w/g, char => char.toUpperCase())}</div>
                                                })}
                                            </div>

                                        </div>
                                    </CallSourceDropDown>
                                </CallSourceDropDownContainer>
                            </div>
                        </div>}
                       {/* // Modality multiselect box */}
                       { user?.oi_profile && user?.oi_profile?.toLowerCase() !== "customer" &&  <div
                                className={styles?.call_context_container}
                                style={{ marginTop: "12px" }}
                            >
                                <div
                                    style={{
                                        borderBottom: "1px solid lightgrey",
                                        position: "relative",
                                        marginRight: "15px",
                                        cursor: "pointer",
                                    }}
                                >
                                    <div
                                        style={{
                                            // fontWeight: "550",
                                            color: "#586C72",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                        }}
                                        onClick={() => {
                                            if (showModality?.length) {
                                                setModality("");
                                            } else {
                                                setModality("none");
                                            }
                                        }}
                                    >
                                        {selectedModalitiesList?.length == 0 ? (
                                            <span>MODALITY</span>
                                        ) : (
                                            <span> {selectedModalitiesList?.length} Selected </span>
                                        )}
                                        <span style={{ marginLeft: "5px" }}>
                                            <ArrowDropDownIcon />
                                        </span>
                                    </div>

                                    <CallSourceDropDownContainer
                                        style={{ display: showModality }}
                                    >
                                        <CallSourceDropDown>
                                            <div className="modal-box" >
                                                <div
                                                    className="centerList"
                                                    style={{ borderBottom: "none", position: "relative" }}
                                                >
                                                    <SearchInputContainer>
                                                        <SearchInput
                                                            placeholder="Search Modality.."
                                                            onChange={searchInputHandler4}
                                                        />
                                                    </SearchInputContainer>

                                                    {modalitiesList?.map((item, index) => (
                                                        <div className="filterbar__dropdown" key={item?.modality_key}>
                                                            <input
                                                                type="checkbox"
                                                                checked={item?.isChecked}
                                                                style={{ marginRight: "5px", marginLeft: "10px" }}
                                                                onChange={() => {
                                                                    let modalityIds = selectedModalitiesList;
                                                                    let modalityList = modalitiesList;
                                                                    let idx = modalityList.findIndex(
                                                                        (each) => each?.modality_key === item?.modality_key
                                                                    );
                                                                    let data = modalityList[idx];
                                                                    if (modalityList[idx]?.isChecked) {
                                                                        data = {
                                                                            ...data,
                                                                            isChecked: false,
                                                                        };
                                                                        modalityIds = modalityIds?.filter(
                                                                            (modality_key) => modality_key !== item.modality_key
                                                                        );
                                                                    } else {
                                                                        data = {
                                                                            ...data,
                                                                            isChecked: true,
                                                                        };
                                                                        modalityIds.push(item?.modality_key);
                                                                    }
                                                                    modalityList[idx] = data;

                                                                    setModalitiesList(() => [...modalityList]);
                                                                    setSelectedModalitiesList(() => [...modalityIds]);
                                                                }}
                                                            />
                                                            <span style={{ fontSize: "15px" }}>{item?.modality_key}</span>
                                                        </div>
                                                    ))}


                                                </div>
                                                <div
                                                    className="modalCloseBtn" style={{ width: '250px' }}
                                                    onClick={() => {
                                                        if (showModality?.length) {
                                                            setModality("");
                                                        } else {
                                                            setModality("none");
                                                        }
                                                    }}
                                                >
                                                    Done
                                                </div>

                                            </div>
                                        </CallSourceDropDown>

                                    </CallSourceDropDownContainer>
                                </div>
                            </div>}

                    <InputFieldWithTitle
                        name={"order_description"}
                        value={searchInputField.order_description}
                        InputHandler={InputHandler}
                        title={"Req Service"}
                        type={"text"}
                        customCss={{ width: "220px" }}
                    />
                    <CallCountInfo>
                        {gotNoOfCalls != null && gotNoOfCalls != 0 && (
                            <CallCount>
                                <span style={{ borderBottom: "2px solid red" }}>
                                    {noOfCallsText()} of {totalNumberOfCall} Records{" "}
                                </span>
                            </CallCount>
                        )}
                    </CallCountInfo>
                    <div>
                        <ButtonContainer>

                            <Button
                                variant="primary"
                                size="sm"
                                onClick={() => SearchHandler(false)}
                                style={{ width: "80px", marginRight: "5px", marginLeft: "10px" }}
                            >
                                Search
                            </Button>
                            <Button
                                variant="warning"
                                onClick={resetHandler}
                                size="sm"
                                style={{ width: "80px", marginRight: "10px", marginLeft: "5px" }}
                            >
                                {" "}
                                Reset{" "}
                            </Button>
                        </ButtonContainer>
                        {searchInputField?.conversation_id && <SearchInfoBox>
                            Ignoring all filters because of CONV# selected.
                        </SearchInfoBox>}
                    </div>
                </InputGroup>
            </InputContainer>
            {/* Buttons and count info */}

        </div>
    );
};

export default SearchBar;
